<template>
  <div>
    <fangan v-if="show"></fangan>
    <SolutionDetails v-else></SolutionDetails>
  </div>
</template>
<script>
import fangan from "./fangan.vue"
import SolutionDetails from "./SolutionDetails/index.vue"
export default{
  metaInfo: {
    title: 'Eiiplat环境产业互联网平台解决方案，环卫智能化解决方案，环保智能化解决方案，大平台',
    meta: [
      { name: 'description', content: '青岛国真智慧Eiiplat环境产业物联网平台是国内首家环境产业工业互联网平台。提供环卫一体化智能解决方案，环境产业平台解决方案，智能施工解决方案，智能设计解决方案，智能收运解决方案，智能供应解决方案，智能管控解决方案，农村厕改智能管护系统解决方案，餐厨垃圾智能收运解决方案，餐厨垃圾施工管理系统。 、机制管理、财务管理、OKR管理八大应用，赋能行业转型升级。利用资金流驱动废弃物的循环流动，优化过程数据提高效率，对废弃物全生命周期追溯，为客户提高生产效率和降低运营成本提供持续的解决方案。' },
      { name: 'keywords', content: '环卫一体化智能解决方案，环境产业平台解决方案，智能施工解决方案，智能设计解决方案，智能收运解决方案，智能供应解决方案，智能管控解决方案，农村厕改智能管护系统解决方案，餐厨垃圾智能收运解决方案，餐厨垃圾施工管理系统。' },
    ],
  },
  components:{
    fangan,
    SolutionDetails
  },
  watch:{
    '$route.query.id':function(newVal,oldVal){
      if(newVal){
        this.show=false
      }else{
        this.show=true
      }
    }
  },
  data(){
    return{
     show:true
    }
  },
  mounted(){
    if(this.$route.query.id){
      this.show=false
    }else{
      this.show=true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Solution.vue